export const supportedCountries = [
  { code: 'TH', name: 'Thailand' },
  { code: 'KR', name: 'South Korea' },
  { code: 'MY', name: 'Malaysia' },
  { code: 'SG', name: 'Singapore' },
  { code: 'ID', name: 'Indonesia' },
  { code: 'VN', name: 'Vietnam' },
  { code: 'KH', name: 'Cambodia' },
  { code: 'LA', name: 'Laos' },
];

export const legalContent = {
  privacy: {
    eyebrow: 'Privacy',
    title: 'Privacy Policy',
    intro:
      'This policy explains how Entrfill handles personal and travel information when you use the Entrfill app and related services.',
    sections: [
      {
        title: 'Information we process',
        body:
          'To provide account, travel-preparation, and arrival-card assistance features, we may process account information, traveler and passport details, itinerary and accommodation details that you provide, membership and payment status, and limited device, security, and diagnostic records.',
      },
      {
        title: 'Why we process it',
        body:
          'We use information to operate your account, help organize travel details you choose to provide, retain information you choose to reuse for future travel, assist with supported visa-application and arrival-card fields after you explicitly trigger a fill, provide support, protect the service, and meet legal obligations.',
      },
      {
        title: 'Sensitive travel details',
        body:
          'Passport numbers, dates of birth, contact details, itineraries, and accommodation details may be sensitive personal information. Entrfill processes these details only as needed for the features you choose and applies access controls, encryption in transit, redacted diagnostics, and role-based operational access.',
      },
      {
        title: 'Sharing and official websites',
        body:
          'Entrfill does not sell personal information. When you open an official destination website, that website is operated by its relevant authority and is governed by its own rules. Information you submit there is handled by that authority.',
      },
      {
        title: 'Your choices',
        body:
          'You can review, correct, or remove information available in the app. To request access, deletion, withdrawal of consent, or account help, use the Contact us channel in Entrfill. We may verify your identity before completing a request.',
      },
      {
        title: 'Updates',
        body:
          'We may update this policy as our service, security practices, or legal requirements change. The current version is made available in Entrfill and on this website.',
      },
    ],
  },
  terms: {
    eyebrow: 'Terms',
    title: 'Terms of Service',
    intro:
      'These terms describe the basic rules for using Entrfill. By using Entrfill, you agree to use the service responsibly and review the latest in-app terms before continuing.',
    sections: [
      {
        title: 'What Entrfill provides',
        body:
          'Entrfill is a travel-form assistant. It helps you organize traveler, passport, itinerary, and accommodation information, review details for reuse, view destination information, and assist with entering confirmed details into supported visa applications and arrival cards after you explicitly trigger it.',
      },
      {
        title: 'What Entrfill does not provide',
        body:
          'Entrfill is not a government agency, embassy, airline, border-control authority, visa processor, or legal adviser. It does not grant visas, determine entry eligibility, make declarations for you, or submit official forms for you.',
      },
      {
        title: 'Your responsibility',
        body:
          'You must provide accurate, current information and have authority to provide information about any traveler. Before submitting an official form, you must review every value, declaration, and supporting document yourself.',
      },
      {
        title: 'Official-site boundaries',
        body:
          'You handle verification codes, sign-in, identity checks, passport uploads, payment, page navigation, declarations, manual branches, and final submission. Entrfill may stop or provide limited assistance when official pages change or restrict access.',
      },
      {
        title: 'Membership and purchases',
        body:
          'Any paid features, prices, validity periods, and renewal terms are shown in the applicable purchase flow and app-store terms. Membership does not guarantee a visa, entry approval, official priority, or a completed submission.',
      },
      {
        title: 'Changes to the service',
        body:
          'Official forms and destination requirements can change without notice. We may change or suspend features when needed for security, compatibility, law, or service operations.',
      },
    ],
  },
  disclaimer: {
    eyebrow: 'Safety boundary',
    title: 'Service Disclaimer',
    intro:
      'Entrfill helps with travel preparation. It does not replace your judgment, the official instructions for your destination, or the authority that decides admission.',
    sections: [
      {
        title: 'No government affiliation',
        body:
          'Entrfill is independent from governments, embassies, consulates, airlines, border-control authorities, and visa-processing agencies.',
      },
      {
        title: 'No travel outcome guarantee',
        body:
          'Destination rules, official websites, document requirements, review processes, and availability can change at any time. Entrfill does not guarantee a visa, entry permission, arrival-card acceptance, or any travel outcome.',
      },
      {
        title: 'Fill assistance only',
        body:
          'Autofill is only available after your explicit action and only for supported fields Entrfill identifies as currently visible and appropriate to assist. Organized details and autofill can help reduce repetitive entry, but the service does not automatically start a fill or submit an official form.',
      },
      {
        title: 'You remain in control',
        body:
          'You must personally read and confirm declarations, health, customs, and other questions requiring judgment. You also handle CAPTCHA, codes, logins, uploads, exceptions, navigation, and final submission.',
      },
      {
        title: 'Review before submission',
        body:
          'Check names, passport details, dates, transport, accommodation, and every declaration on the official page before submission. You are responsible for information ultimately submitted to any government authority or third party.',
      },
    ],
  },
} as const;
